const contextsMixin = (Base = null) => class extends Base {

	injectContexts(contexts) {
		this.contexts = contexts;
	}

};

export default contextsMixin;
